export const INSIGHT_ANALYTICS_EVENTS = {
  DOCUMENT_PARSE_EMPTY: 'insight_document_parse_empty',
  DOCUMENT_REPROCESS_CLICKED: 'insight_document_reprocess_clicked',
} as const;
